import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiKeyList } from './ApiKeyList';
import { CreateApiKeyModal } from './CreateApiKeyModal';

const ApiKeys = () => {
  const { t } = useTranslation();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <div className="mb-6 p-6 rounded-xl bg-white shadow-sm">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">{t('apiKeys.title')}</h1>
          <button
            className="btn btn-primary"
            onClick={() => setIsCreateModalOpen(true)}
          >
            {t('apiKeys.createNew')}
          </button>
        </div>
      </div>

      <ApiKeyList />

      <CreateApiKeyModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </>
  );
};

export default ApiKeys; 